import { getExtension } from '../utils/file'
import { resourceMediaTypes } from '../utils/constants'

export const defaultResourceClass = {
  organizationType: null,
  classLayout: null,
  minutesDuration: null,
  startSection: '',
  developmentSection: '',
  closureSection: '',
  valuationSection: '',
  necessaryMaterials: [],
  studentStatement: ''
}

export const defaultLocalizedResource = {
  locale: '',
  title: '',
  mediaPresentation: '',
  mediaPresentationType: null,
  rhetoricalQuestion: '',
  benefits: '',
  mediaTeacher: '',
  mediaTeacherType: null,
  mediaTeacherSummary: '',
  pedagogicalGoal: '',
  classPlanDescription: '',
  classPlans: [],
  mediaStudent: '',
  mediaStudentType: null,
  mediaStudentSummary: ''
}

export const defaultResourceGeneralInfo = {
  resourceType: null,
  ageRangeId: null,
  secondaryAgeRangeId: null,
  skillIds: [],
  subjectIds: [],
  odsIds: [],
  keywords: []
}

export const mapKreaResourceData = (resource) => {
  const hasLocalized = resource.localizedResources.length
  if (!hasLocalized) {
    return {
      generalInfo: {
        resourceType: resource.resourceType,
        ageRangeId: resource.ageRangeId,
        secondaryAgeRangeId: resource.secondaryAgeRangeId,
        skillIds: resource.skillIds,
        subjectIds: resource.subjectIds,
        odsIds: resource.odsIds,
        keywords: resource.keywords
      },
      localizedResources: []
    }
  } else {
    return {
      generalInfo: {
        resourceType: resource.resourceType,
        ageRangeId: resource.ageRangeId,
        secondaryAgeRangeId: resource.secondaryAgeRangeId,
        skillIds: resource.skillIds,
        subjectIds: resource.subjectIds,
        odsIds: resource.odsIds,
        keywords: resource.keywords
      },
      localizedResources: resource.localizedResources
    }
  }
}

export const getMediaType = (filename) => {
  const fileExtension = getExtension(filename)
  if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') return resourceMediaTypes.image
  return resourceMediaTypes.video
}
